namespace Advant.Crossroads {
    interface IConfirmDeleteHighSchoolScope extends angular.IScope {
        cfncHighSchoolExists: boolean;
        transcriptSchoolExists: boolean;
        fafsaSchoolExists: boolean;
        highSchool: IHighSchool;
        loading: boolean;
        deleteCfncSchool: boolean;
        deleteTranscriptSchool: boolean;
        deleteFafsaSchool: boolean;


        delete: () => void;
        cancel: () => void;

    }

    interface IConfirmDeleteHighSchool { }

    class ConfirmDeleteHighSchool implements IConfirmDeleteHighSchool {
        static controllerId: string = "confirmDeleteHighSchool";
        static $inject: any = ["$scope", "$uibModalInstance", "dialogs", "common", "highSchoolService", "data"]
        log: (msg, data?, showHowl?) => void;
        logError: (msg, data?, showHowl?) => void;

        

        constructor(private $scope: IConfirmDeleteHighSchoolScope,
            private $uibModalInstance: angular.ui.bootstrap.IModalServiceInstance,
            private dialogs: angular.dialogs.IDialogService,
            private common: ICommonService,
            private highSchoolService: IHighSchoolService,
            private highSchool: IHighSchool
        ) {
            $scope.highSchool = highSchool;
            $scope.loading = true;
            $scope.deleteCfncSchool = false;
            $scope.deleteTranscriptSchool = false;
            $scope.deleteFafsaSchool = false;

            $scope.delete = () => this.delete();
            $scope.cancel = () => this.cancel();


            var getCfncSchool = this.highSchoolService.getCfncSchool(this.highSchool.name, this.highSchool.ceebCode)
                .then(result => $scope.cfncHighSchoolExists = result != null);

            var transcriptSchoolExists = this.highSchoolService.transcriptSchoolExists(this.highSchool.ceebCode)
                .then(result => $scope.transcriptSchoolExists = result);

            var fafsaSchoolExists = this.highSchoolService.fafsaSchoolExists(this.highSchool.fafsaId)
                .then(result => $scope.fafsaSchoolExists = result);

            this.common.$q.all([getCfncSchool, transcriptSchoolExists, fafsaSchoolExists]).then(() => {
                $scope.loading = false;
            })
        }


        delete() {
            var promises = [];
            if (this.$scope.deleteCfncSchool) {
                promises.push(this.highSchoolService.deleteCfncSchool(this.highSchool.ceebCode));
            }

            if (this.$scope.deleteTranscriptSchool) {
                promises.push(this.highSchoolService.deleteTranscriptSchool(this.highSchool.ceebCode));
            }

            if (this.$scope.deleteFafsaSchool) {
                promises.push(this.highSchoolService.deleteFafsaSchool(this.highSchool.fafsaId));
            }

            this.common.$q.all(promises).then(() => {
                this.$uibModalInstance.close();
            });
        }

        cancel() {
            this.$uibModalInstance.dismiss("cancel");
        }

    }

    angular.module("app").controller(ConfirmDeleteHighSchool.controllerId, ConfirmDeleteHighSchool);
}